/**
 * api/*Api.tsx içindeki fonksiyonlar hata durumunda `throw` etmek yerine axios
 * hata nesnesini `return` ediyor. Çağıran taraf `data?.success` baktığı için
 * hatalarda `data` undefined kalıyor ve **hiçbir şey olmuyordu** — kullanıcı
 * kaydet'e basıyor, ekran sessiz kalıyordu.
 *
 * `unwrap` iki şekli de tek bir sonuca indirger; böylece çağıran taraf her
 * zaman başarısızlığı görebilir.
 */
export interface ApiResult<T = any> {
  ok: boolean;
  data: T | null;
  message: string | null;
  status: number | null;
}

const DEFAULT_ERROR = "İşlem sırasında beklenmedik bir hata oluştu.";
const NETWORK_ERROR = "Sunucuya bağlanılamadı. Bağlantınızı kontrol edin.";

export const unwrap = <T = any>(res: any): ApiResult<T> => {
  // Başarılı axios yanıtı
  if (res?.data?.success) {
    return { ok: true, data: res.data, message: null, status: res.status ?? 200 };
  }

  // Backend 200 döndü ama success:false
  if (res?.data && "success" in res.data) {
    return {
      ok: false,
      data: res.data,
      message: res.data.message ?? res.data.error ?? DEFAULT_ERROR,
      status: res.status ?? 200,
    };
  }

  // Yakalanıp return edilmiş axios hatası
  const response = res?.response;
  if (response) {
    return {
      ok: false,
      data: null,
      message:
        response.data?.message ?? response.data?.error ?? errorForStatus(response.status),
      status: response.status ?? null,
    };
  }

  // Ağ hatası (sunucuya hiç ulaşılamadı)
  return { ok: false, data: null, message: NETWORK_ERROR, status: null };
};

const errorForStatus = (status?: number) => {
  if (status === 403) return "Bu işlem için yetkiniz yok.";
  if (status === 404) return "Kayıt bulunamadı.";
  if (status === 400) return "Gönderilen bilgiler geçersiz.";
  return DEFAULT_ERROR;
};
